export default "/_next/static/chunks/fonts/Montserrat Bold-1e9aae576ff61a31004d38a97764fb3a.otf";